<template>
  <div>
    <img :src="$store.state.imagetocrop.image" class="croppable" id="crop-image" />
    <div class="controls">
      <button @click="crop" class="btn edit-save">
        <span v-show="!cropping"> <i class="fa fa-crop"></i> Crop </span>
        <i class="fa fa-circle-o-notch fa-spin" v-show="cropping"></i>
      </button>
      <button @click="$store.commit('clearImageToCrop')" class="btn edit-cancel">
        <i class="fa fa-undo"></i> Cancel
      </button>
    </div>
  </div>
</template>

<script>
import api from "@/services/api"
import "cropperjs/dist/cropper.css"

export default {
  name: "ImageCrop",
  props: ["internal"],
  data: function() {
    return { cropping: false }
  },
  methods: {
    crop: function() {
      this.cropping = true

      var data = this.$store.state.cropper.getData(true)
      data.url = this.$store.state.imagetocrop.image
      api.cropImage(data, this.internal).then(response => {
        this.$store.state.cropObj[this.$store.state.cropProp] = response.data.Location
        this.$store.commit("clearImageToCrop")
        this.cropping = false
      })
    }
  }
}
</script>

<style scoped>
/* Limit image width to avoid overflow the container */
img {
  max-width: 100%; /* This rule is very important, please do not ignore this! */
  max-height: 50vh;
}
.controls {
  padding-top: 1rem;
}
</style>
